import { all, /*call,*/ put, takeLatest } from 'redux-saga/effects';
import * as types from '../constants/actionTypes';
// import config from 'react-global-configuration';

/**
 * Bookmarks
 */
export function* loadBookmarks() {
  try {
    // raw response
    // const options = { method: 'GET' };
    //const response = yield call(request, url, options, 'application/json');
    // const response = [{'id':'cz', 'name':'Trh Česká republika ', 'users':['1']}]; // temporarily hardcoded Czech bookmark
    const response = [];
    yield put({
      type: types.BOOKMARKS_SUCCESS,
      payload: response,
    });
  } catch (err) {
    console.log('error', err);
    /* istanbul ignore next */
    yield put({
      type: types.BOOKMARKS_FAILURE,
      payload: err,
    });
  }
}

export function* saveBookmark(payload) {
  try {
    // raw response
    // const options = { method: 'GET' };
    console.log('-------');
    console.log(payload);
    //const response = yield call(request, url, options, 'application/json');
    const response = {
      id: payload.bookmark.id
        ? payload.bookmark.id
        : Math.floor(Math.random() * 1000),
      name: payload.bookmark.name,
      users: payload.bookmark.users,
      vins: payload.bookmark.vins,
    };
    yield put({
      type: types.SAVE_BOOKMARK_SUCCESS,
      payload: response,
      new: !payload.bookmark.id,
    });
  } catch (err) {
    console.log('error', err);
    /* istanbul ignore next */
    yield put({
      type: types.SAVE_BOOKMARK_FAILURE,
      payload: err,
    });
  }
}

export function* deleteBookmark(payload) {
  try {
    // raw response
    // const options = { method: 'DELETE' };
    //const response = yield call(request, url, options, 'application/json');
    // const response = {"id":payload.bookmark.id ? payload.bookmark.id : Math.floor(Math.random() * 1000), "name":payload.bookmark.name, "users":payload.bookmark.users, "vins": payload.bookmark.vins};
    yield put({
      type: types.DELETE_BOOKMARK_SUCCESS,
      id: payload.bookmark.id,
    });
  } catch (err) {
    console.log('error', err);
    /* istanbul ignore next */
    yield put({
      type: types.DELETE_BOOKMARK_FAILURE,
      payload: err,
    });
  }
}

/**
 * Users
 */
export function* loadUsers() {
  try {
    // raw response
    // const options = { method: 'GET' };
    //const response = yield call(request, url, options, 'application/json');
    const response = [
      { id: '1', name: 'Martin' },
      { id: '2', name: 'Tomas' },
    ];
    yield put({
      type: types.USERS_SUCCESS,
      payload: response,
    });
  } catch (err) {
    console.log('error', err);
    /* istanbul ignore next */
    yield put({
      type: types.USERS_FAILURE,
      payload: err,
    });
  }
}

/**
 * User Sagas
 */
export default function* root() {
  yield all([
    takeLatest(types.USERS_LOADING, loadUsers),
    takeLatest(types.BOOKMARKS_LOADING, loadBookmarks),
    takeLatest(types.SAVE_BOOKMARK_REQUEST, saveBookmark),
    takeLatest(types.DELETE_BOOKMARK_REQUEST, deleteBookmark),
  ]);
}
